<template>
  <div class="page">
    <section class="info-wrap">
      <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
        <el-form-item class="style" prop="appAppidBelong" label="APPID所属">
          <div>
            <el-radio-group v-model="ruleForm.appAppidBelong">
              <el-radio :label="'0'">服务商应用APPID</el-radio>
              <el-radio :label="'1'">商家应用APPID</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item v-if="ruleForm.appAppidBelong == '0'" label="服务商应用APPID" prop="appAppid">
          <el-input v-model="ruleForm.appAppid" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item v-if="ruleForm.appAppidBelong == '1'" label="商家应用APPID" prop="appSubAppid">
          <el-input v-model="ruleForm.appSubAppid" placeholder="" clearable></el-input>
        </el-form-item>
        <el-form-item class="style" label="APP截图" prop="appPics">
          <div class="img-wrap">
            <div class="img-list">
              <el-upload
                :class="ruleForm.appPics && ruleForm.appPics.length > 3 ? 'hide' : ''"
                list-type="picture-card"
                :file-list="imgList"
                :action="$configUrl.uploadUrl"
                :on-remove="handleRemove"
                :on-success="
                  (response, file, fileList) => {
                    return appPicsSuccess(file, fileList);
                  }
                "
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <div class="style"></div>
              <p class="labels-tips">请提供APP首页截图、尾页截图、应用内截图、支付页截图各一张。</p>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number || Boolean,
      default: false,
    },
    allData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      imgList: [],
      ruleForm: {
        appAppid: '',
        appSubAppid: '',
        appAppidBelong: '0',
        appPics: [],
      },
      rules: {
        appAppidBelong: [{ required: true, message: '', trigger: ['blur', 'change'] }],
        appAppid: [{ required: true, message: '请输入服务商应用APPID', trigger: ['blur', 'change'] }],
        appSubAppid: [{ required: true, message: '请输入商家应用APPID', trigger: ['blur', 'change'] }],
        appPics: [{ required: true, message: '请上传APP截图', trigger: ['blur', 'change'] }],
      },
    };
  },

  watch: {
    count: {
      handler: function () {
        this.validity();
      },
    },
    allData: {
      handler: function (data) {
        console.log(data);
        if (data.businessDataVO) {
          this.ruleForm = JSON.parse(JSON.stringify(data.businessDataVO));
          let appPicsList = data.businessDataVO.appPics.split(',');
          this.imgList = appPicsList.map((item) => {
            const fileItem = {
              name: 'file',
              url: item,
              response: {
                data: item,
              },
            };
            return fileItem;
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    appPicsSuccess(file) {
      this.ruleForm.appPics.push(file.response.data.url);
    },
    handleRemove(file, fileList) {
      this.setImgurl(fileList);
    },
    setImgurl(fileList) {
      const result = [];
      for (let item of fileList) {
        console.log(item);
        item.size
          ? result.push({
              url: item.response.data,
            })
          : result.push({
              url: item.url,
            });
      }
      this.ruleForm.appPics = result;
    },
    validity() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('confirm', { flag: true, ruleForm: this.ruleForm });
        } else {
          this.$emit('confirm', { flag: false, ruleForm: this.ruleForm });
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.info-wrap {
  box-sizing: border-box;
  padding-left: 31px;
}
.img-wrap {
  width: 700px;
  .img-list {
    height: 80px;
    overflow: hidden;
  }
  /deep/ .el-upload--picture-card {
    width: 58px;
    height: 58px;
    line-height: 58px;
  }
  /deep/ .el-upload-list {
    /deep/.el-upload-list__item.is-success:first-child {
      &::before {
        position: absolute;
        left: 0;
        top: 0;
        content: '主图';
        color: #fff;
        width: 100%;
        height: 22px;
        font-size: 12px;
        text-align: center;
        line-height: 22px;
        background: rgba(0, 0, 0, 0.36);
      }
    }
  }
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
    box-sizing: border-box;
  }
  /deep/ .el-upload--picture-card i {
    font-size: 14px;
  }
  /deep/ .el-upload-list__item-actions {
    width: 80px;
    height: 80px;
  }
  .hide {
    /deep/ .el-upload.el-upload--picture-card {
      display: none;
    }
  }
}
.labels-tips {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #999999;
}
/deep/.el-input {
  width: 346px;
}
.style {
  margin-bottom: 7px;
}
</style>
